var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/common/utilities/extract-section-id.js
function extractSectionId(element) {
    element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
    return element.id.replace("shopify-section-", "");
}

export {
    extractSectionId
};

// js/common/behavior/scroll-area.js
var ScrollArea = class {
    constructor(element, abortController2 = null) {
      this._element = element;
      this._allowTriggerNearingStartEvent = false;
      this._allowTriggerLeavingStartEvent = true;
      this._allowTriggerNearingEndEvent = true;
      this._allowTriggerLeavingEndEvent = false;
      new ResizeObserver(throttle(this._checkIfScrollable.bind(this))).observe(element);
      this._element.addEventListener("scroll", throttle(this._onScroll.bind(this)), { signal: abortController2?.signal });
    }
    get scrollNearingThreshold() {
      return 125;
    }
    get scrollDirection() {
      if (this._element.scrollWidth > this._element.clientWidth) {
        return "inline";
      } else if (this._element.scrollHeight > this._element.clientHeight) {
        return "block";
      } else {
        return "none";
      }
    }
    _checkIfScrollable() {
      this._element.classList.toggle("is-scrollable", this.scrollDirection !== "none");
    }
    _onScroll() {
      clearTimeout(this._scrollTimeout);
      this._lastScrollPosition = this._lastScrollPosition ?? (this.scrollDirection === "inline" ? Math.abs(this._element.scrollLeft) : Math.abs(this._element.scrollTop));
      let direction;
      if (this.scrollDirection === "inline") {
        direction = this._lastScrollPosition > Math.abs(this._element.scrollLeft) ? "start" : "end";
        this._lastScrollPosition = Math.abs(this._element.scrollLeft);
      } else {
        direction = this._lastScrollPosition > Math.abs(this._element.scrollTop) ? "start" : "end";
        this._lastScrollPosition = Math.abs(this._element.scrollTop);
      }
      const scrollPosition = Math.round(Math.abs(this.scrollDirection === "inline" ? this._element.scrollLeft : this._element.scrollTop)), scrollMinusSize = Math.round(this.scrollDirection === "inline" ? this._element.scrollWidth - this._element.clientWidth : this._element.scrollHeight - this._element.clientHeight);
      if (direction === "start" && this._allowTriggerNearingStartEvent && scrollPosition <= this.scrollNearingThreshold) {
        this._allowTriggerNearingStartEvent = false;
        this._allowTriggerLeavingStartEvent = true;
        this._element.dispatchEvent(new CustomEvent("scroll:edge-nearing", { bubbles: true, detail: { position: "start" } }));
      } else if (direction === "end" && scrollPosition > this.scrollNearingThreshold) {
        this._allowTriggerNearingStartEvent = true;
        if (this._allowTriggerLeavingStartEvent) {
          this._allowTriggerLeavingStartEvent = false;
          this._element.dispatchEvent(new CustomEvent("scroll:edge-leaving", { bubbles: true, detail: { position: "start" } }));
        }
      }
      if (direction === "end" && this._allowTriggerNearingEndEvent && scrollMinusSize <= scrollPosition + this.scrollNearingThreshold) {
        this._allowTriggerNearingEndEvent = false;
        this._allowTriggerLeavingEndEvent = true;
        this._element.dispatchEvent(new CustomEvent("scroll:edge-nearing", { bubbles: true, detail: { position: "end" } }));
      } else if (direction === "start" && scrollMinusSize > scrollPosition + this.scrollNearingThreshold) {
        this._allowTriggerNearingEndEvent = true;
        if (this._allowTriggerLeavingEndEvent) {
          this._allowTriggerLeavingEndEvent = false;
          this._element.dispatchEvent(new CustomEvent("scroll:edge-leaving", { bubbles: true, detail: { position: "end" } }));
        }
      }
      if (window.onscrollend === void 0) {
        this._scrollTimeout = setTimeout(() => {
          this._element.dispatchEvent(new CustomEvent("scrollend", { bubbles: true, composed: true }));
        }, 75);
      }
    }
};

// js/common/utilities/dom.js
function throttle(callback) {
    let requestId = null, lastArgs;
    const later = (context) => () => {
      requestId = null;
      callback.apply(context, lastArgs);
    };
    const throttled = (...args) => {
      lastArgs = args;
      if (requestId === null) {
        requestId = requestAnimationFrame(later(this));
      }
    };
    throttled.cancel = () => {
      cancelAnimationFrame(requestId);
      requestId = null;
    };
    return throttled;
}

// js/common/behavior/custom-cursor.js
var _abortController, _onPointerLeave, onPointerLeave_fn, _onPointerMove, onPointerMove_fn;
var CustomCursor = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onPointerLeave);
    __privateAdd(this, _onPointerMove);
    __privateAdd(this, _abortController, void 0);
  }
  connectedCallback() {
    __privateSet(this, _abortController, new AbortController());
    this.parentElement.addEventListener("pointermove", __privateMethod(this, _onPointerMove, onPointerMove_fn).bind(this), { passive: true, signal: __privateGet(this, _abortController).signal });
    this.parentElement.addEventListener("pointerleave", __privateMethod(this, _onPointerLeave, onPointerLeave_fn).bind(this), { signal: __privateGet(this, _abortController).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
};
_abortController = new WeakMap();
_onPointerLeave = new WeakSet();
onPointerLeave_fn = function() {
  this.classList.remove("is-visible", "is-half-start", "is-half-end");
};
_onPointerMove = new WeakSet();
onPointerMove_fn = function(event) {
  if (event.target.matches("button, a[href], button :scope, a[href] :scope")) {
    return this.classList.remove("is-visible");
  }
  const parentBoundingRect = this.parentElement.getBoundingClientRect(), parentXCenter = (parentBoundingRect.left + parentBoundingRect.right) / 2, isOnStartHalfPart = event.pageX < parentXCenter;
  this.classList.toggle("is-half-start", isOnStartHalfPart);
  this.classList.toggle("is-half-end", !isOnStartHalfPart);
  this.classList.add("is-visible");
  const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2, mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
  this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
  this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
};
if (!window.customElements.get("custom-cursor")) {
  window.customElements.define("custom-cursor", CustomCursor);
}

// js/common/actions/controls.js
var PageDots = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this.items = Array.from(this.children);
      this.items.forEach((button, index) => button.addEventListener("click", () => this.select(index), { signal: this._abortController.signal }));
      this.addEventListener("control:filter", this._filterItems, { signal: this._abortController.signal });
      if (this.controlledElement) {
        this.controlledElement.addEventListener("carousel:change", (event) => {
            var selected = event.detail.index !== -1 ? event.detail.index : parseInt(this.closest('.product-gallery').querySelector('media-carousel').getAttribute('initial-index'));
            this.select(selected, false);
        }, { signal: this._abortController.signal });
      }

      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => {
          this.select(this.items.indexOf(event.target))
        });
      }
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get controlledElement() {
      return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
    }
    get selectedIndex() {
      return this.items.findIndex((button) => button.getAttribute("aria-current") === "true");
    }
    select(selectedIndex, dispatchEvent = true) {
      if (this.hasAttribute("align-selected")) {
        this.scrollTo({
          top: this.items[selectedIndex].offsetTop,
          behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto"
        });
      }
      if (this.selectedIndex === selectedIndex) {
        return;
      }
      this.items.forEach((button, index) => button.setAttribute("aria-current", selectedIndex === index ? "true" : "false"));
      if (dispatchEvent) {
        this._dispatchEvent(selectedIndex);
      }
    }
    _filterItems(event) {
      this.items.forEach((item, index) => item.hidden = event.detail.filteredIndexes.includes(index));
    }
    _dispatchEvent(index) {
      (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:select", { bubbles: true, cancelable: true, detail: { index } }));
    }
};
var PrevButton = class extends HTMLButtonElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this.addEventListener("click", () => (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:prev", { bubbles: true, cancelable: true })), { signal: this._abortController.signal });
      // if (this.controlledElement) {
      //   this.controlledElement.addEventListener("scroll:edge-nearing", (event) => this.disabled = event.detail.position === "start", { signal: this._abortController.signal });
      //   this.controlledElement.addEventListener("scroll:edge-leaving", (event) => this.disabled = event.detail.position === "start" ? false : this.disabled, { signal: this._abortController.signal });
      // }
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get controlledElement() {
      return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
    }
};
var NextButton = class extends HTMLButtonElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this.addEventListener("click", () => (this.controlledElement ?? this).dispatchEvent(new CustomEvent("control:next", { bubbles: true, cancelable: true })), { signal: this._abortController.signal });
      // if (this.controlledElement) {
      //   this.controlledElement.addEventListener("scroll:edge-nearing", (event) => this.disabled = event.detail.position === "end", { signal: this._abortController.signal });
      //   this.controlledElement.addEventListener("scroll:edge-leaving", (event) => this.disabled = event.detail.position === "end" ? false : this.disabled, { signal: this._abortController.signal });
      // }
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get controlledElement() {
      return this.hasAttribute("aria-controls") ? document.getElementById(this.getAttribute("aria-controls")) : null;
    }
};
if (!window.customElements.get("page-dots")) {
    window.customElements.define("page-dots", PageDots);
}
if (!window.customElements.get("prev-button")) {
    window.customElements.define("prev-button", PrevButton, { extends: "button" });
}
if (!window.customElements.get("next-button")) {
    window.customElements.define("next-button", NextButton, { extends: "button" });
}

// js/common/carousel/base-carousel.js
var BaseCarousel = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this._reloaded = false;
      if (Shopify.designMode) {
        this.closest(".shopify-section").addEventListener("shopify:section:select", (event) => this._reloaded = event.detail.load);
      }
      if (this.items.length > 1) {
        if (Shopify.designMode) {
          this.addEventListener("shopify:block:select", (event) => {
            this.select(this.items.indexOf(event.target), { animate: !event.detail.load })
          });
        }
        if (this.hasAttribute("adaptive-height")) {
          this.addEventListener("carousel:settle", this._adjustHeight);
          this._adjustHeight();
        }
        this.addEventListener("carousel:select", this._preloadImages, { signal: this._abortController.signal });
        this.addEventListener("carousel:filter", this._filterItems, { signal: this._abortController.signal });
        this.addEventListener("control:prev", this.previous, { signal: this._abortController.signal });
        this.addEventListener("control:next", this.next, { signal: this._abortController.signal });
        this.addEventListener("control:select", (event) => this.select(event.detail.index), { signal: this._abortController.signal });
      }
      if (this.selectedIndex === 0) {
        this._dispatchEvent("carousel:select", 0);
      } else {
        this.select(this.selectedIndex, { animate: false, force: true });
      }
    }
    disconnectedCallback() {
      this._abortController.abort();
    }
    get items() {
      if (this.hasAttribute("reversed")) {
        return this._items = this._items || Array.from(this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children).reverse();
      } else {
        return this._items = this._items || Array.from(this.hasAttribute("selector") ? this.querySelectorAll(this.getAttribute("selector")) : this.children);
      }
    }
    get visibleItems() {
      return this.items.filter((item) => item.offsetParent !== null);
    }
    get selectedIndex() {
      return this._selectedIndex = this._selectedIndex ?? parseInt(this.getAttribute("initial-index") || 0);
    }
    get selectedIndexAmongVisible() {
      return this.visibleItems.indexOf(this.selectedSlide);
    }
    get loop() {
      return true;
    }
    get selectedSlide() {
      return this.items[this.selectedIndex];
    }
    get previousSlide() {
      return this.visibleItems[this.loop ? (this.selectedIndexAmongVisible - 1 + this.visibleItems.length) % this.visibleItems.length : Math.max(this.selectedIndexAmongVisible - 1, 0)];
    }
    get nextSlide() {
      return this.visibleItems[this.loop ? (this.selectedIndexAmongVisible + 1 + this.visibleItems.length) % this.visibleItems.length : Math.min(this.selectedIndexAmongVisible + 1, this.visibleItems.length - 1)];
    }
    previous(animate11 = true) {
      this.select(this.items.indexOf(this.previousSlide), { direction: "previous", animate: animate11 });
    }
    next(animate11 = true) {
      this.select(this.items.indexOf(this.nextSlide), { direction: "next", animate: animate11 });
    }
    _transitionTo(fromSlide, toSlide, options = {}) {
    }
    _adjustHeight() {
      if(this.selectedIndexAmongVisible === -1){
        this._selectedIndex = parseInt(this.getAttribute("initial-index") || 0);
      }
      if (this.hasAttribute("adaptive-height") && this.selectedSlide.clientHeight !== this.clientHeight) {
        this.style.maxHeight = `${this.selectedSlide.clientHeight}px`;
      }
      if (this.hasAttribute("adaptive-height")){
        this.closest('.product.product--large').style.setProperty('--height-gallery', `${this.selectedSlide.clientHeight}px`);
      }
      
    }
    _filterItems(event) {
      this.items.forEach((item, index) => item.hidden = event.detail.filteredIndexes.includes(index));
    }
    _preloadImages() {
      [this.previousSlide, this.nextSlide].forEach((item) => {
        if (item) {
          Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
        }
      });
    }
    _dispatchEvent(eventName, index) {
      this.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: { slide: this.items[index], index } }));
    }
};

// js/common/carousel/scroll-carousel.js
var ScrollCarousel = class extends BaseCarousel {
    constructor() {
      super();
      if (window.ResizeObserver) {
        new ResizeObserver(throttle(this._adjustHeight.bind(this))).observe(this);
      }
    }
    connectedCallback() {
      this._hasPendingProgrammaticScroll = false;
      this._scrollArea = new ScrollArea(this, this._abortController);
      super.connectedCallback();
      this.addEventListener("scroll", throttle(this._onCarouselScroll.bind(this)), { signal: this._abortController.signal });
      this.addEventListener("scrollend", this._onScrollSettled, { signal: this._abortController.signal });
    }
    get itemOffset() {
      return this.visibleItems.length < 2 ? 0 : this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
    }
    get slidesPerPage() {
      return this.visibleItems.length < 2 ? 1 : Math.floor((this.clientWidth - this.visibleItems[0].offsetLeft) / (Math.abs(this.itemOffset) - (parseInt(getComputedStyle(this).gap) || 0)));
    }
    get totalPages() {
      return this.visibleItems.length < 2 ? 1 : this.visibleItems.length - this.slidesPerPage + 1;
    }
    select(index, { animate: animate11 = true, force = false } = {}) {
      const indexBeforeChange = this.selectedIndex;
      if (!this.offsetParent || this._scrollArea.scrollDirection === "none") {
        return this._selectedIndex = index;
      }
      const indexAmongVisible = this.visibleItems.indexOf(this.items[index]);
      index = this.items.indexOf(this.visibleItems[Math.min(this.totalPages, indexAmongVisible)]);
      this._selectedIndex = index;
      this._dispatchEvent("carousel:select", index);
      if (index !== indexBeforeChange || force) {
        const [fromSlide, toSlide] = [this.items[indexBeforeChange], this.items[index]];
        this._dispatchEvent("carousel:change", index);
        this._transitionTo(fromSlide, toSlide, { animate: animate11 });
      }
    }
    /**
     * Transition using the scrollTo method. To prevent the intersection observer to caught up the change, we set up
     * a "hasPendingProgrammaticScroll" variable to true, that is set back to false once the scroll has settled
     */
    _transitionTo(fromSlide, toSlide, { animate: animate11 = true } = {}) {
      fromSlide?.classList.remove("is-selected");
      toSlide?.classList.add("is-selected");
      let slideAlign = this._extractSlideAlign(toSlide), scrollAmount = 0;
      switch (slideAlign) {
        case "start":
          scrollAmount = this.itemOffset * this.visibleItems.indexOf(toSlide);
          break;
        case "center":
          scrollAmount = toSlide.offsetLeft - (this.clientWidth / 2 - (parseInt(getComputedStyle(this).scrollPaddingInline) || 0)) + toSlide.clientWidth / 2;
          break;
      }
      this._hasPendingProgrammaticScroll = animate11;
      this.scrollTo({ left: scrollAmount, behavior: animate11 ? "smooth" : "auto" });
    }
    /**
     * Update the index when manually scrolling (which allows to update the controls)
     */
    _onCarouselScroll() {
      if (this._hasPendingProgrammaticScroll || this._scrollArea.scrollDirection === "none") {
        return;
      }
      const newIndex = this.items.indexOf(this.visibleItems[Math.round(this.scrollLeft / this.itemOffset)]);
      if (newIndex !== this.selectedIndex) {
        this._selectedIndex = newIndex;
        this._dispatchEvent("carousel:select", this.selectedIndex);
        this._dispatchEvent("carousel:change", this.selectedIndex);
      }
    }
    /**
     * On the scroll has settled we dispatch the event (which covers both programmatic scroll and swipe)
     */
    _onScrollSettled() {
      this._hasPendingProgrammaticScroll = false;
      this._dispatchEvent("carousel:settle", this.selectedIndex);
    }
    _adjustHeight() {
      this.style.maxHeight = null;
      if (this._scrollArea.scrollDirection !== "none") {
        super._adjustHeight();
      }
    }
    _extractSlideAlign(slide) {
      return getComputedStyle(slide).scrollSnapAlign === "center" ? "center" : "start";
    }
};

// js/common/product/product-gallery.js
import { PhotoSwipeLightbox } from "//evisu.com.au/cdn/shop/t/67/assets/vendor.min.js?v=161072099565793977701781511073";
var ProductGallery = class extends HTMLElement {
    constructor() {
      super();
      this._onVariantChangedListener = this._onVariantChanged.bind(this);
      this.thumbnailBarElement = null;
    }
    connectedCallback() {
      document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChangedListener);
      this._carousels = Array.from(this.querySelectorAll("media-carousel"));
      this._pageDots = Array.from(this.querySelectorAll("page-dots"));
      this._viewInSpaceButton = this.querySelector("[data-shopify-xr]");
      this._customCursor = this.querySelector(".product-gallery__cursor");
      this.addEventListener("carousel:change", this._onCarouselChanged);
      if (this._viewInSpaceButton) {
        this.addEventListener("carousel:settle", this._updateViewInSpaceButton);
      }
      if (this.hasAttribute("allow-zoom")) {
        this.addEventListener("lightbox:open", (event) => this.openZoom(event.detail.index));
      }
    }
    disconnectedCallback() {
      document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChangedListener);
    }

    get photoswipe() {
      if (this._photoswipe) {
        return this._photoswipe;
      }

      // const items = Array.from(this.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) > img')).map((image) => {
      //   return {
      //     thumbnailElement: image,
      //     src: image.src,
      //     srcset: image.srcset,
      //     msrc: image.currentSrc || image.src,
      //     width: parseInt(image.getAttribute("width")),
      //     height: parseInt(image.getAttribute("height")),
      //     alt: image.alt,
      //     thumbCropped: true
      //   };
      // });

      const photoswipe = new PhotoSwipeLightbox({
        pswpModule: () => import("//evisu.com.au/cdn/shop/t/67/assets/photoswipe.min.js?v=159985852772823468811781511067"),
        bgOpacity: 1,
        maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
        closeTitle: window.themeVariables.strings.closeGallery,
        zoomTitle: window.themeVariables.strings.zoomGallery,
        errorMsg: window.themeVariables.strings.errorGallery,
        // UX
        arrowPrev: false,
        arrowNext: false,
        counter: false,
        zoom: false,
        closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
          <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
          <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
          <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
        </svg>`
      });

      photoswipe.addFilter("thumbEl", (thumbEl, data) => data["thumbnailElement"]);
      photoswipe.on("uiRegister", () => {
        photoswipe.pswp.ui.registerElement({
          name: "bottom-bar",
          order: 5,
          appendTo: "wrapper",
          html: `
            <div class="pagination">
              <button class="pagination__item group" rel="prev">
                <span class="animated-arrow animated-arrow--reverse"></span>
              </button>
              
              <span class="pagination__current text-sm">
                <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
              </span>
              
              <button class="pagination__item group" rel="next">
                <span class="animated-arrow"></span>
              </button>
            </div>
          `,
          onInit: (el, pswp) => {
            el.querySelector(".pagination__page-count").innerText = pswp.getNumItems();
            el.querySelector('[rel="prev"]')?.addEventListener("click", () => pswp.prev());
            el.querySelector('[rel="next"]')?.addEventListener("click", () => pswp.next());  

            // const container = el.querySelector(".thumbnail-container");
  
            // function updateThumbnails() {
            //   container.innerHTML = ''; // Clear existing thumbnails
  
            //   items.forEach((item, index) => {
            //     const wrapper = document.createElement('div');
            //     wrapper.classList.add('thumbnail-wrapper');  // Optional: add a class for styling
  
            //     const imageElement = document.createElement('img');
            //     imageElement.className = 'thumbnail-image object-contain';
            //     imageElement.src = item.msrc || item.src; 
            //     imageElement.alt = item.alt; 
            //     imageElement.style.width = '100%';
            //     imageElement.style.height = 'auto';
  
            //     imageElement.onclick = () => { pswp.goTo(index); };
  
            //     wrapper.appendChild(imageElement);
            //     container.appendChild(wrapper);
            //   });
            // }
  
            // function updateThumbnailsActiveClass() {
            //   const thumbnails = container.querySelectorAll('.thumbnail-wrapper');
            //   thumbnails.forEach((thumb, idx) => {
            //       if (idx === pswp.currIndex) {
            //           thumb.classList.add('active');
            //           thumb.scrollIntoView({
            //             behavior: 'smooth', 
            //             block: 'nearest',  
            //             inline: 'center'
            //           });
            //       } else {
            //           thumb.classList.remove('active');
            //       }
            //   });
            // }
  
            // updateThumbnails(); // Initial thumbnail creation
            // updateThumbnailsActiveClass();

            pswp.on("change", () => {
              el.querySelector(".pagination__current-page").innerText = pswp.currIndex + 1;
              // updateThumbnails(); 
              // updateThumbnailsActiveClass();
            });
          }
        });
      });

      photoswipe.init();
      return this._photoswipe = photoswipe;
    }

    updatePhotoSwipeUI(items) {
      const photoswipe = this.photoswipe;

      photoswipe.on("uiRegister", () => {
        const thumbnailBar = document.createElement("div");
        thumbnailBar.classList.add("thumbnail-bar");
        thumbnailBar.innerHTML = `
          <div class="thumbnail-slider-left"><div class="thumbnail-container"></div></div>
        `;

        this.thumbnailBarElement = thumbnailBar;
        // Đoạn code để đăng ký giao diện UI của PhotoSwipe
        photoswipe.pswp.ui.registerElement({
          name: "thumbnail-bar",
          order: 5,
          appendTo: "wrapper",
          html: thumbnailBar.outerHTML,
          onInit: (el, pswp) => {
            const container = el.querySelector(".thumbnail-container");
  
            function updateThumbnails() {
              container.innerHTML = ''; // Clear existing thumbnails
  
              items.forEach((item, index) => {
                const wrapper = document.createElement('div');
                wrapper.classList.add('thumbnail-wrapper');  // Optional: add a class for styling
  
                const imageElement = document.createElement('img');
                imageElement.className = 'thumbnail-image object-contain';
                imageElement.src = item.msrc || item.src; 
                imageElement.alt = item.alt; 
                imageElement.style.width = '100%';
                imageElement.style.height = 'auto';
  
                imageElement.onclick = () => { pswp.goTo(index); };
  
                wrapper.appendChild(imageElement);
                container.appendChild(wrapper);
              });
            }
  
            function updateThumbnailsActiveClass() {
              const thumbnails = container.querySelectorAll('.thumbnail-wrapper');
              thumbnails.forEach((thumb, idx) => {
                  if (idx === pswp.currIndex) {
                      thumb.classList.add('active');
                      thumb.scrollIntoView({
                        behavior: 'smooth', 
                        block: 'nearest',  
                        inline: 'center'
                      });
                  } else {
                      thumb.classList.remove('active');
                  }
              });
            }
  
            updateThumbnails(); // Initial thumbnail creation
            updateThumbnailsActiveClass();
  
            pswp.on("change", () => {
              updateThumbnails(); 
              updateThumbnailsActiveClass();
            });
          }
        });
      });
    }

    /**
     * Open the zoom by dynamically creating a data source based on the filtered items
     */
    openZoom(index = 0) {
      const dataSource = Array.from(this.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) > img')).map((image) => {
        return {
          thumbnailElement: image,
          src: image.src,
          srcset: image.srcset,
          msrc: image.currentSrc || image.src,
          width: parseInt(image.getAttribute("width")),
          height: parseInt(image.getAttribute("height")),
          alt: image.alt,
          thumbCropped: true
        };
      });

      const photoswipe = this.photoswipe; // Lấy đối tượng PhotoSwipe
      
      photoswipe.loadAndOpen(index, dataSource); // Mở ảnh với dữ liệu mới
      this.updatePhotoSwipeUI(dataSource);
    }
    _updateViewInSpaceButton(event) {
      if (event.detail.slide.getAttribute("data-media-type") === "model") {
        this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", event.detail.slide.getAttribute("data-media-id"));
      } else {
        this._viewInSpaceButton.setAttribute("data-shopify-model3d-id", this._viewInSpaceButton.getAttribute("data-shopify-model3d-default-id"));
      }
    }
    _onCarouselChanged(event) {
      if (this._customCursor) {
        this._customCursor.toggleAttribute("hidden", event.detail.slide.getAttribute("data-media-type") !== "image");
      }
    }
    _onVariantChanged(event) {
      const filteredIndexes = this._getFilteredMediaIndexes(event.detail.product, event.detail.variant);
      this._carousels.forEach((carousel) => carousel.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes } })));
      this._pageDots.forEach((pageDots) => pageDots.dispatchEvent(new CustomEvent("control:filter", { detail: { filteredIndexes } })));
      if (event.detail.variant["featured_media"] && event.detail.previousVariant["featured_media"] && event.detail.previousVariant["featured_media"]["id"] !== event.detail.variant["featured_media"]["id"] || !event.detail.previousVariant["featured_media"] && event.detail.variant["featured_media"]) {
        this._carousels.forEach((carousel) => carousel.select(event.detail.variant["featured_media"]["position"] - 1, { animate: false }));
      }
    }
    _getFilteredMediaIndexes(product, variant) {
      const filteredMediaIds = [];
      product["media"].forEach((media) => {
        let matchMedia = variant["featured_media"] && media["position"] === variant["featured_media"]["position"];
        if (media["alt"]?.includes("#") && media["alt"] !== product["title"]) {
          if (!matchMedia) {
            const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
            product["options"].forEach((option) => {
              if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
                if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                  filteredMediaIds.push(media["position"] - 1);
                }
              }
            });
          }
        }
      });
      return filteredMediaIds;
    }
};
  
var MediaCarousel = class extends ScrollCarousel {
    constructor() {
      super();
      this.isDragging = false;
      this.hasMoved = false;
      this.startX = 0;
      this.endX = 0;
    }

    connectedCallback() {
      super.connectedCallback();
      this._onGestureChangedListener = this._onGestureChanged.bind(this);
      this.addEventListener("gesturestart", this._onGestureStart, { capture: false, signal: this._abortController.signal });
      this.addEventListener("carousel:settle", this._onMediaSettled, { signal: this._abortController.signal });

      this.addEventListener("mouseleave", (e) => {
        this.isDragging = false;
      });

      this.addEventListener("mousedown", (e) => {
        this.startX = e.clientX;
        this.isDragging = true;
        this.hasMoved = false;
      });

      // Giữ nguyên mouseleave

      this.addEventListener("mouseup", (e) => {
        if (this.isDragging && this.hasMoved) {
          e.preventDefault();
          this.isDragging = false;
          this.handleDragGesture(e.clientX);
        } else {
          this._onGalleryClick(e);
        }
        this.isDragging = false;
      });

      this.addEventListener("mousemove", (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        this.hasMoved = true;
        this.endX = e.clientX;
      });

      this.addEventListener("touchstart", (e) => {
        const touch = e.touches[0];
        this.startX = touch.clientX;
        this.isDragging = true;
        this.hasMoved = false;
      }, { passive: true });

      this.addEventListener("touchmove", (e) => {
        if (!this.isDragging) return;
        const touch = e.touches[0];
        this.endX = touch.clientX;
        this.hasMoved = true;
      }, { passive: true });

      this.addEventListener("touchend", (e) => {
        if (this.isDragging && this.hasMoved) {
          this.handleDragGesture(this.endX);
        }
        this.isDragging = false;
      }, { passive: true });
    }

    handleDragGesture(finalX) {
      const threshold = window.matchMedia("(max-width: 768px)").matches ? 60 : 100;
      const deltaX = finalX - this.startX;
      
      if (Math.abs(deltaX) > threshold) {
        deltaX > 0 ? this.previous() : this.next();
      }
    }

    _onMediaSettled(event) {
      const media = event.detail.slide;
      this.items.filter((item) => ["video", "external_video", "model"].includes(item.getAttribute("data-media-type"))).forEach((item) => {
        // item.firstElementChild.pause()
         item.querySelector("video")?.pause()
      }
                                                                                                                              );
      switch (media.getAttribute("data-media-type")) {
        case "external_video":
        case "video":
          if (this.hasAttribute("autoplay")) {
            // media.firstElementChild.play();
             media.querySelector("video")?.play()
          }
          break;
        case "model":
          if (window.matchMedia("(min-width: 1000px)").matches) {
            // media.firstElementChild.play();
             media.querySelector("video")?.play()
          }
          break;
      }
    }
    _onGalleryClick(event) {
      // let media = event.target.parentNode, openIndex;
      // if (media) {
      //   const visibleImages = this.closest("media-carousel").visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      //   openIndex = visibleImages.indexOf(media);
      // } else {
      //   const carousel = this.closest(".product-gallery__media-list-wrapper").querySelector("media-carousel"), 
      //   visibleImages = carousel.visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      //   openIndex = visibleImages.indexOf(carousel.selectedSlide);
      // }
      // this.dispatchEvent(new CustomEvent("lightbox:open", {
      //   bubbles: true,
      //   detail: {
      //     index: openIndex
      //   }
      // }));

      let media = event.target.parentNode, openIndex;
      if (media) {
        // Lọc các hình ảnh có thuộc tính data-media-type là "image" và không bị ẩn
        const visibleImages = this.closest("media-carousel").visibleItems
          .filter((item) => item.getAttribute("data-media-type") === "image" && item.style.display !== 'none');
        openIndex = visibleImages.indexOf(media);
      } else {
        const carousel = this.closest(".product-gallery__media-list-wrapper").querySelector("media-carousel"), 
        // Tương tự, lọc chỉ bao gồm các hình ảnh hiển thị
        visibleImages = carousel.visibleItems
          .filter((item) => item.getAttribute("data-media-type") === "image" && item.style.display !== 'none');
        openIndex = visibleImages.indexOf(carousel.selectedSlide);
      }
      this.dispatchEvent(new CustomEvent("lightbox:open", {
        bubbles: true,
        detail: {
          index: openIndex
        }
      }));

      document.addEventListener('lightbox:open', this._handleLightboxOpen(event.target));
      
    }
    
    _handleLightboxOpen(el) {
      const thumbsContainer = document.createElement('div');
        thumbsContainer.className = 'photoSwipe_innerthumbs';
        // el.parentNode.appendChild(thumbsContainer);

        // Clone and append thumbnail images
        // document.querySelectorAll('#thumbnails img').forEach(img => {
        //   const clonedImg = img.cloneNode(true);
        //   thumbsContainer.appendChild(clonedImg);
        //   clonedImg.addEventListener('click', (e) => {
        //     Array.from(thumbsContainer.querySelectorAll('img')).forEach(img => img.classList.remove('svifaded'));
        //     e.target.classList.add('svifaded');
        //     lightbox.goTo(Array.from(thumbsContainer.querySelectorAll('img')).indexOf(e.target));
        //   });
        // });

        // // Highlight the active thumbnail
        // thumbsContainer.querySelectorAll('img')[lightbox.getCurrentIndex()].classList.add('svifaded');
    }

    _onGestureStart(event) {
      event.preventDefault();
      this.addEventListener("gesturechange", this._onGestureChangedListener, { capture: false, signal: this._abortController.signal });
    }
    _onGestureChanged(event) {
      event.preventDefault();
      if (event.scale > 1.5) {
        this.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true, detail: { index: this.selectedIndexAmongVisible } }));
        this.removeEventListener("gesturechange", this._onGestureChangedListener);
      }
    }
};
  
var _onPointerZoomMove, onPointerZoomMove_fn, _onPointerZoomLeave, onPointerZoomLeave_fn;
var ProductZoomButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this._onButtonClicked);
    __privateAdd(this, _onPointerZoomLeave);
    __privateAdd(this, _onPointerZoomMove);
  }

  connectedCallback() {
    this.parentElement.addEventListener("pointermove", __privateMethod(this, _onPointerZoomMove, onPointerZoomMove_fn).bind(this), { passive: true });
    this.parentElement.addEventListener("pointerleave", __privateMethod(this, _onPointerZoomLeave, onPointerZoomLeave_fn).bind(this));
  }

  _onButtonClicked() {
    let media = this.closest(".product-gallery__media"), openIndex;
    if (media) {
      const visibleImages = this.closest("media-carousel").visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      openIndex = visibleImages.indexOf(media);
    } else {
      const carousel = this.closest(".product-gallery__media-list-wrapper").querySelector("media-carousel"), visibleImages = carousel.visibleItems.filter((item) => item.getAttribute("data-media-type") === "image");
      openIndex = visibleImages.indexOf(carousel.selectedSlide);
    }
    this.dispatchEvent(new CustomEvent("lightbox:open", {
      bubbles: true,
      detail: {
        index: openIndex
      }
    }));
  }
};

_onPointerZoomLeave = new WeakSet();
onPointerZoomLeave_fn = function() {
  this.classList.remove("is-visible");
};
_onPointerZoomMove = new WeakSet();
onPointerZoomMove_fn = function(event) {
  if (event.target.matches('.prev-next-buttons *')) {
    return this.classList.remove("is-visible");
  }

  const parentBoundingRect = this.parentElement.getBoundingClientRect();
  this.classList.add("is-visible");
  const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2, mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
  this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
  this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
};

if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}
// if (!window.customElements.get("product-zoom-button")) {
//   window.customElements.define("product-zoom-button", ProductZoomButton, { extends: "button" });
// }
if (!window.customElements.get("media-carousel")) {
  window.customElements.define("media-carousel", MediaCarousel);
}

// js/common/behavior/custom-cursor.js
var _abortController, _onPointerLeave, onPointerLeave_fn, _onPointerMove, onPointerMove_fn;
var CustomCursor = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onPointerLeave);
    __privateAdd(this, _onPointerMove);
    __privateAdd(this, _abortController, void 0);
  }
  connectedCallback() {
    __privateSet(this, _abortController, new AbortController());
    this.parentElement.addEventListener("pointermove", __privateMethod(this, _onPointerMove, onPointerMove_fn).bind(this), { passive: true, signal: __privateGet(this, _abortController).signal });
    this.parentElement.addEventListener("pointerleave", __privateMethod(this, _onPointerLeave, onPointerLeave_fn).bind(this), { signal: __privateGet(this, _abortController).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
};
_abortController = new WeakMap();
_onPointerLeave = new WeakSet();
onPointerLeave_fn = function() {
  this.classList.remove("is-visible", "is-half-start", "is-half-end");
};
_onPointerMove = new WeakSet();
onPointerMove_fn = function(event) {
  if (event.target.matches("button, a[href], button :scope, a[href] :scope")) {
    return this.classList.remove("is-visible");
  }
  const parentBoundingRect = this.parentElement.getBoundingClientRect(), parentXCenter = (parentBoundingRect.left + parentBoundingRect.right) / 2, isOnStartHalfPart = event.pageX < parentXCenter;
  this.classList.toggle("is-half-start", isOnStartHalfPart);
  this.classList.toggle("is-half-end", !isOnStartHalfPart);
  this.classList.add("is-visible");
  const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2, mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
  this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
  this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
};
if (!window.customElements.get("custom-cursor")) {
  window.customElements.define("custom-cursor", CustomCursor);
}

const url = new URL(window.location);
if(!url.pathname.includes('/collections') && !url.pathname.includes('/products')) {
  console.log('Not collection or product page');
  window.localStorage.removeItem('productLinkClicked');
  window.localStorage.removeItem('productLinkRemovedClicked', '');
}